const { mergeMap } = require("rxjs/operators");
const { ofType } = require("redux-observable");

const { marketplace: marketplaceApi } = require("@doctoroncallcom/api");
const {
  CREATE_TRANSACTION,
  GET_INVOICE,
  GET_TRANSACTIONS,
  GET_TRANSACTION,
  UPDATE_ADDRESS,
  CART_CHECKOUT,
  TRANSACTION_DELIVERY,
  DELIVERY_PRICELIST,
  DELIVERY_LIST_PROVIDERS,
} = require("./constants");

const {
  createTransactionSuccess,
  createTransactionError,

  getInvoiceSuccess,
  getInvoiceError,

  getTransactionsSuccess,
  getTransactionsError,

  getTransactionSuccess,
  getTransactionError,

  updateAddressSuccess,
  updateAddressError,

  cartCheckOutSuccess,
  cartCheckOutError,

  transactionDeliverySuccess,
  transactionDeliveryError,

  deliveryPricelistSuccess,
  deliveryPricelistError,

  deliveryProviderslistSuccess,
  deliveryProviderslistError,
} = require("./actions");

const createTransaction = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(CREATE_TRANSACTION),
    mergeMap((action) =>
      marketplaceApi.marketTransaction
        .createTransaction(marketplace, action.payload.data)
        .then((response) => createTransactionSuccess(response.data))
        .catch((error) => createTransactionError(error))
    )
  );

const getInvoice = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_INVOICE),
    mergeMap((action) =>
      marketplaceApi.marketTransaction
        .getInvoice(marketplace, {
          uuid: action.payload.uuid,
        })
        .then((response) => getInvoiceSuccess(response.data))
        .catch((error) => getInvoiceError(error))
    )
  );

const getTransactions = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_TRANSACTIONS),
    mergeMap((action) =>
      marketplaceApi.marketTransaction
        .getTransactions(marketplace, {
          _page: action.payload.page,
          _pagesize: action.payload.pageSize,
        })
        .then((response) => getTransactionsSuccess(response.data))
        .catch((error) => getTransactionsError(error))
    )
  );

const getTransaction = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_TRANSACTION),
    mergeMap((action) =>
      marketplaceApi.marketTransaction
        .getTransaction(marketplace, action.payload.uuid, {
          is_business: action.payload.isBusiness,
        })
        .then((response) => getTransactionSuccess(response.data))
        .catch((error) => getTransactionError(error))
    )
  );

const updateAddress = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(UPDATE_ADDRESS),
    mergeMap((action) =>
      marketplaceApi.marketTransaction
        .updateAddress(marketplace, {
          address_id: action.payload.addressId,
          ref_id: action.payload.refId,
        })
        .then((response) => updateAddressSuccess(response.data))
        .catch((error) => updateAddressError(error))
    )
  );

const cartCheckout = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(CART_CHECKOUT),
    mergeMap((action) =>
      marketplaceApi.marketTransaction
        .cartCheckout(marketplace, action.payload.data)
        .then((response) => cartCheckOutSuccess(response.data))
        .catch((error) => cartCheckOutError(error))
    )
  );

const transactionDelivery = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(TRANSACTION_DELIVERY),
    mergeMap((action) =>
      marketplaceApi.marketTransaction
        .delivery(marketplace, {
          ref_id: action.payload.refId,
          order_id: action.payload.orderId,
          provider_id: action.payload.providerId,
        })
        .then((response) => transactionDeliverySuccess(response.data))
        .catch((error) => transactionDeliveryError(error))
    )
  );

const deliveryPricelist = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(DELIVERY_PRICELIST),
    mergeMap((action) =>
      marketplaceApi.marketTransaction
        .deliveryPricelist(marketplace, {
          ref_id: action.payload.refId,
          order_id: action.payload.orderId,
        })
        .then((response) => deliveryPricelistSuccess(response.data))
        .catch((error) => deliveryPricelistError(error))
    )
  );
const deliveryProviderslist = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(DELIVERY_LIST_PROVIDERS),
    mergeMap((action) =>
      marketplaceApi.marketTransaction
        .getDeliveryProvider(marketplace, action.payload.id)
        .then((response) => deliveryProviderslistSuccess(response.data))
        .catch((error) => deliveryProviderslistError(error))
    )
  );
module.exports = {
  createTransaction,
  getInvoice,
  getTransactions,
  getTransaction,
  updateAddress,
  cartCheckout,
  transactionDelivery,
  deliveryPricelist,
  deliveryProviderslist,
};
